import styled from "@emotion/styled";
import Colors from "styles/colors";
import { SUBMENU_BORDER, sectionHeaderStyles } from "../submenu-shared.scss";
export const StyledAiSubmenuComponent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors["white"]};

  .section-header {
    ${sectionHeaderStyles}
  }

  .ai-submenu-main-title {
    font-size: 14px;
    font-weight: 300;
    color: ${Colors["asphalt"]};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  .use-cases-section {
    padding: 32px 0;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 28px;

    .use-case-item {
      display: flex;
      align-items: center;
      gap: 16px;
      text-decoration: none;

      .use-case-icon {
        width: 36px;
        height: 36px;
        border-radius: 12px;
        flex-shrink: 0;
        object-fit: cover;
      }

      .use-case-text {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .use-case-title {
          font-size: 1rem;
          font-weight: 400;
          color: ${Colors["Black"]};
        }

        .use-case-desc {
          font-size: 0.875rem;
          color: ${Colors["asphalt"]};
        }
      }
    }
  }

  .capabilities-section {
    padding: 25px 0;
    flex-shrink: 0;
    border-top: ${SUBMENU_BORDER};
    display: flex;
    flex-direction: column;
    gap: 8px;

    .capability-item {
      display: flex;
      align-items: center;
      height: 40px;
      text-decoration: none;

      .capability-label {
        font-size: 1rem;
        color: ${Colors["Black"]};
        font-weight: 400;
      }

      &:hover .capability-label {
        color: ${Colors["brand-iris"]};
      }
    }
  }
`;
